import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import styled, { css } from 'styled-components';
import { u as useIsMobile } from '../theme/MobileThemeProvider/useIsMobile-B-VP6bHU.js';
import { p as paddingMixin, m as mobilePaddingMixin } from '../theme/style-mixins/padding/index-BPYuRWh5.js';
import { i as isMobile } from '../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';

const Container = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-40026394__sc-79445s-0"
})(["align-items:center;box-sizing:border-box;display:flex;flex-direction:column;flex-wrap:nowrap;justify-content:center;width:100%;", " ", " ", ";", ";", ""], ({
  theme,
  $bgColor
}) => $bgColor && css(["background-color:", ";"], theme.surface[$bgColor]), paddingMixin, ({
  theme,
  $marginBlockStart
}) => $marginBlockStart && css(["margin-block-start:", ";"], theme.spacing[$marginBlockStart].default), ({
  theme,
  $marginBlockEnd
}) => $marginBlockEnd && css(["margin-block-end:", ";"], theme.spacing[$marginBlockEnd].default), isMobile(css(["", " ", ";", ";"], mobilePaddingMixin, ({
  theme,
  $marginBlockStart
}) => $marginBlockStart && css(["margin-block-start:", ";"], theme.spacing[$marginBlockStart].mobile), ({
  theme,
  $marginBlockEnd
}) => $marginBlockEnd && css(["margin-block-end:", ";"], theme.spacing[$marginBlockEnd].mobile))));
const Content = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-40026394__sc-79445s-1"
})(["align-content:stretch;align-items:center;box-sizing:border-box;display:flex;flex-direction:column;flex-wrap:nowrap;justify-content:center;width:100%;max-width:", ";"], ({
  theme,
  $contentMaxWidth
}) => theme.layout.maxWidth[$contentMaxWidth]);
const Section = ({
  children,
  padding = 'large',
  paddingBlockStart,
  paddingBlockEnd,
  marginBlockStart = 'none',
  marginBlockEnd = 'none',
  bgColor = 'default',
  paddingInline,
  contentMaxWidth = 'fluid',
  ...rest
}) => {
  const isMobilePlatform = useIsMobile();
  return /*#__PURE__*/React__default.createElement(Container, _extends({}, rest, {
    $padding: padding,
    $paddingBlockStart: paddingBlockStart,
    $paddingBlockEnd: paddingBlockEnd,
    $paddingInlineStart: paddingInline,
    $paddingInlineEnd: paddingInline,
    $marginBlockStart: marginBlockStart,
    $marginBlockEnd: marginBlockEnd,
    $bgColor: bgColor,
    $isMobile: isMobilePlatform
  }), /*#__PURE__*/React__default.createElement(Content, {
    $contentMaxWidth: contentMaxWidth
  }, children));
};

export { Section as S };
//# sourceMappingURL=Section-DMzrvly8.js.map
